export enum Language {
  et = 'et',
  en = 'en',
  lv = 'lv',
}

export enum Country {
  EE = 'EE',
  KE = 'KE',
  ZA = 'ZA',
  LV = 'LV',
  EG = 'EG',
}

export type Locale = `${Language}-${Country}`;
